import PropTypes from 'prop-types';

export const WeeksOfMonth = {
  First: 'First',
  Second: 'Second',
  Third: 'Third',
  Fourth: 'Fourth',
  Last: 'Last',
};

export const WeeksOfMonthPropTypes = PropTypes.shape({
  First: PropTypes.string.isRequired,
  Second: PropTypes.string.isRequired,
  Third: PropTypes.string.isRequired,
  Fourth: PropTypes.string.isRequired,
  Last: PropTypes.string.isRequired,
});
